import { render, staticRenderFns } from "./UpsertTunnelGroupsDialog.vue?vue&type=template&id=4c0712c3"
import script from "./UpsertTunnelGroupsDialog.vue?vue&type=script&lang=ts"
export * from "./UpsertTunnelGroupsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports